import React, { useState } from "react";
import styles from "./Header.module.scss";
import cancelBtn from "../../assets/icons/closeModal.svg";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import { Modal } from "@mui/material";
import VerifyModal from "../Authentication/VerifyModal";
import LoginModal from "../Authentication/LoginModal";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../redux/Selectors";
import { logout, openLoginModal } from "../../redux/slices/authSlice";
import { getLangFromPath } from "../../utils/getLangFromPath ";
import { t } from "i18next";

const MobileMenu = ({ setOpenedMenu }) => {
  const user = useSelector(userSelector);
  const [openedModal, setOpenedModal] = useState(false);
  const [verifyModal, setVerifyModal] = useState(false);
  const lang=getLangFromPath();
  const dispatch = useDispatch();
  const handleOpen = () => {
    setOpenedMenu(false);
    dispatch(openLoginModal(true));
  };
  const handleClose = () => {
    setOpenedModal(false);
    setVerifyModal(false);
  };
  const handleVerify = () => {
    setVerifyModal(!verifyModal);
  };
  return (
    <div className={styles.mobileMenu}>
      <div className={styles.cancelBtn} onClick={() => setOpenedMenu(false)}>
        <img src={cancelBtn} alt="" />
      </div>
      <Link
        onClick={() => setOpenedMenu(false)}
        className={styles.logo}
        to={`${lang}`}
      >
        <img src={logo} />
      </Link>
      {user && (
          <ul className={styles.userInfo}>
          <li>
            <Link
              onClick={() => setOpenedMenu(false)}
              to={{
                pathname: `/${lang}/my-account`,
                state: { content: "Personal information" },
              }}
            >
              {t('userInfo.myAccount')}
            </Link>
          </li>
          <li>
            <Link
              onClick={() => setOpenedMenu(false)}
              to={{
                pathname: `/${lang}/my-account`,
                state: { content: "Saved properties" },
              }}
            >
              {t('userInfo.savedProperties')}
            </Link>
          </li>
          <li>
            <Link
              onClick={() => setOpenedMenu(false)}
              to={{
                pathname: `/${lang}/my-account`,
                state: { content: "Personal information" },
              }}
            >
              {t('userInfo.personalInformation')}
            </Link>
          </li>
        </ul>
      )}
         <ul>
      <li>
        <Link onClick={() => setOpenedMenu(false)} to={`/${lang}/buy`}>
          {t('header.buy')}
        </Link>
      </li>
      <li>
        <Link onClick={() => setOpenedMenu(false)} to={`/${lang}/rent`}>
          {t('header.rent')}
        </Link>
      </li>
      <li>
        <Link onClick={() => setOpenedMenu(false)} to={`/${lang}/commercial`}>
          {t('header.commercial')}
        </Link>
      </li>
      <li>
        <Link onClick={() => setOpenedMenu(false)} to={`/${lang}/new-projects`}>
          {t('header.new-projects')}
        </Link>
      </li>
      <li>
        <Link onClick={() => setOpenedMenu(false)} to={`/${lang}/find-agent`}>
          {t('header.find-agent')}
        </Link>
      </li>
      <li>
        <Link onClick={() => setOpenedMenu(false)} to={`/${lang}/mortgages`}>
          {t('header.mortgages')}
        </Link>
      </li>
      <li>
        <Link onClick={() => setOpenedMenu(false)} to={`/${lang}/contact-us`}>
          {t('header.contact-us')}
        </Link>
      </li>
    </ul>
      {user ? (
        <button onClick={() => dispatch(logout())} className={styles.loginBtn}>
          {t('userInfo.logout')}
        </button>
      ) : (
        <button onClick={handleOpen} className={styles.loginBtn}>
                  {t('header.login-btn')}

        </button>
      )}
      <div className={styles.menuFooter}>
        <p>{t("copyright")}</p>
        <ul>
        <li>
        <a href="">{t('footer.terms')}</a>
      </li>
      <li>
        <a href="">{t('footer.privacy')}</a>
      </li>
      <li>
        <a href="">{t('footer.cookies')}</a>
      </li>
        </ul>
      </div>
      <Modal open={openedModal} onClose={handleClose}>
        {verifyModal ? (
          <VerifyModal handleVerify={handleVerify} handleClose={handleClose} />
        ) : (
          <LoginModal handleVerify={handleVerify} handleClose={handleClose} />
        )}
      </Modal>
    </div>
  );
};

export default MobileMenu;
